<wa-dialog label="select staff members" open="true" lightDismiss=false withoutHeader=true withFooter="true">
  <div class="wa-stack">
    <h3 class="wa-heading-m">Edit survey</h3>
    <app-survey-properties
      [survey]="survey"
      (inputEvent)="properties=$event">
    </app-survey-properties>
    <app-upload
      (selectedEvent)="selectedFile=$event">
    </app-upload>
  </div>
  <div slot="footer">
    <div class="wa-cluster">
      <wa-button variant="neutral" appearance="filled" (click)="cancel()">Cancel</wa-button>
      @if (stateValid() && surveyChanged() && (!processing)) {
        <wa-button
          variant="brand"
          (click)="save()">
          Save
        </wa-button>
      } @else if (processing) {
        <wa-button
          variant="brand"
          [disabled]="true"
          (click)="save()">
          <wa-icon name="spinner-third" class="fa-spin"></wa-icon>
        </wa-button>
      } @else {
        <wa-button
          variant="brand"
          [disabled]="true"
          (click)="save()">
          Save
        </wa-button>
      }
    </div>
  </div>
</wa-dialog>
